module.exports = __webpack_public_path__ + "static/media/cw.5e1e838d.svg";